<script setup>
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="col-md-12"
          v-if="
            dataChanges.kontraktorId != null &&
            dataChanges.statusChanges === 'created'
          "
        >
          <div
            class="d-flex align-items-center p-3 mb-4 text-dark bg-danger bg-gradient rounded shadow-sm opacity-75"
          >
            <font-awesome-icon
              icon="fa-solid fa-circle-exclamation"
              class="me-2 fs-2"
              style="color: #eeecec"
            />
            <div class="lh-1">
              <h1 class="h6 mb-0 text-white lh-1 fw-light">
                Perubahan data profile kontraktor sedang diverifikasi oleh Admin
              </h1>
              <a
                class="fw-bolder text-decoration-none text-white fs-8 text-decoration-none"
                >Anda tidak dapat melakukan perubahan data sebelum diverifikasi
                oleh Admin</a
              >
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="changesInformation.kontraktorId != null">
          <div
            v-if="
              changesInformation.statusChanges == 'approved' && flashMessage
            "
            class="d-flex align-items-center p-3 mb-4 text-dark bg-success bg-gradient rounded shadow-sm opacity-75"
          >
            <font-awesome-icon
              icon="fa-solid fa-circle-check"
              class="me-2 fs-2"
              style="color: #eeecec"
            />
            <div class="lh-1">
              <h1 class="h6 mb-0 text-white lh-1 fw-light">
                Perubahan data profile kontraktor telah diverifikasi oleh Admin
              </h1>
            </div>
          </div>
          <div
            v-else-if="
              changesInformation.statusChanges == 'rejected' && flashMessage
            "
            class="d-flex align-items-center p-3 mb-4 text-dark bg-danger bg-gradient rounded shadow-sm opacity-75"
          >
            <font-awesome-icon
              icon="fa-solid fa-circle-exclamation"
              class="me-2 fs-2"
              style="color: #eeecec"
            />
            <div class="lh-1">
              <h1 class="h6 mb-0 text-white lh-1 fw-light">
                Perubahan data profile kontraktor ditolak oleh Admin dengan
                alasan {{ changesInformation.reason }}
              </h1>
            </div>
          </div>
        </div>
        <div class="alert alert-warning" role="alert" v-if="sio?.status == 8">
          <p class="m-0 fs-6 fw-bold">
            Pengajuan CoC anda membutuhkan update data profile
          </p>
          <span class="fs-7">Catatan : {{ sio?.reason }}</span>
        </div>
        <div class="bg-white rounded-top-10 w-100" style="min-height: 60vh">
          <div class="container p-5">
            <div class="row mb-5">
              <div class="col-md-12">
                <div class="d-flex">
                  <div class="pr-2" style="margin-right: 1rem">
                    <font-awesome-icon
                      v-if="url_icon == ''"
                      icon="fa-solid fa-building"
                      style="height: 3rem; color: #df4444"
                    />
                    <img v-else :src="url_icon" style="height: 3rem" />
                  </div>
                  <div class="row w-100">
                    <div class="col-md-10">
                      <p
                        class="mb-1"
                        style="
                          font-size: 2rem;
                          line-height: 1.5rem;
                          font-family: 'Inter-Bold';
                        "
                      >
                        {{ kontraktor.namaKontraktor }}
                      </p>
                      <div style="font-size: 1rem">
                        Nilai Prakualifikasi : {{ kontraktor.nilaiPraKplh }} |
                        Predikat PJP :
                        <span
                          v-if="kontraktor.predikat == 'HIJAU'"
                          class="text-success"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-square"
                            style=""
                          />
                          {{
                            kontraktor.nilaiPredikat != null
                              ? kontraktor.nilaiPredikat
                              : "-"
                          }}
                        </span>
                        <span
                          v-else-if="kontraktor.predikat == 'EMAS'"
                          style="color: #e19140"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-square"
                            style=""
                          />
                          {{
                            kontraktor.nilaiPredikat != null
                              ? kontraktor.nilaiPredikat
                              : "-"
                          }}
                        </span>
                        <span
                          v-else-if="kontraktor.predikat == 'BIRU'"
                          style="color: #326bd5"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-square"
                            style=""
                          />
                          {{
                            kontraktor.nilaiPredikat != null
                              ? kontraktor.nilaiPredikat
                              : "-"
                          }}
                        </span>
                        <span
                          v-else-if="kontraktor.predikat == 'HITAM'"
                          style="color: #171716"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-square"
                            style=""
                          />
                          {{
                            kontraktor.nilaiPredikat != null
                              ? kontraktor.nilaiPredikat
                              : "-"
                          }}
                        </span>
                        <span
                          v-else-if="kontraktor.predikat == 'MERAH'"
                          class="text-danger"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-square"
                            style=""
                          />
                          {{
                            kontraktor.nilaiPredikat != null
                              ? kontraktor.nilaiPredikat
                              : "-"
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <button
                        type="button"
                        @click="editProfile()"
                        class="btn btn_cari w-100"
                        :disabled="dataChanges.statusChanges === 'created'"
                      >
                        Edit Profile
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col-md-9">
                <table class="table table-borderless" v-if="sio">
                  <tbody
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    <tr>
                      <td width="20%">Dokumen CoC</td>
                      <td width="1%">:</td>
                      <td>
                        <i
                          v-if="
                            sio.documentIdSio == null || sio.documentIdSio == ''
                          "
                          class="text-danger"
                          >Belum ada dokumen CoC</i
                        >
                        <a
                          v-else
                          @click="downloadFileEsign(sio.documentIdSio, 'coc')"
                          class="text-danger cursor-pointer"
                        >
                          <font-awesome-icon
                            style="color: #dd3737; cursor: pointer"
                            icon="fa-solid fa-file-arrow-down"
                          />
                          Download Dokumen CoC
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>Pengesahan PJO</td>
                      <td>:</td>
                      <td>
                        <a
                          v-if="sio?.documentIdPjo && sio?.documentIdPjo != ''"
                          @click="downloadFileEsign(sio.documentIdPjo, 'pjo')"
                          class="text-danger cursor-pointer"
                        >
                          <font-awesome-icon
                            style="color: #dd3737; cursor: pointer"
                            icon="fa-solid fa-file-arrow-down"
                          />
                          Download Surat Pengesahan PJO
                        </a>
                        <i v-else class="text-danger">
                          Belum ada dokumen pengesahan PJO
                        </i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p
                  class="mb-1"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  INFORMASI UMUM
                </p>
                <div class="d-flex mb-1">
                  <p
                    class="me-5"
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    Inisial : {{ kontraktor.inisial }}
                  </p>
                  <p
                    class="me-5"
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    Klasifikasi : {{ kontraktor.jenis }}
                  </p>
                  <p
                    class="me-5"
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-location-dot"
                      style=""
                    />
                    {{ kontraktor.wilayah == null ? "-" : kontraktor.wilayah }}
                  </p>
                  <p
                    class="me-5"
                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                  >
                    Kualifikasi Usaha :
                    {{
                      kontraktor.kualifikasiUsaha == 1
                        ? "Kecil"
                        : kontraktor.kualifikasiUsaha == 2
                        ? "Sedang"
                        : kontraktor.kualifikasiUsaha == 3
                        ? "Besar"
                        : "-"
                    }}
                  </p>
                </div>
                <!-- <hr class="hr" /> -->
                <p
                  class="mb-1"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  IZIN LEGALITAS
                </p>
                <div class="d-flex mb-2">
                  <table class="table table-borderless">
                    <tbody
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      <tr>
                        <td width="20%">No. NIB</td>
                        <td width="1%">:</td>
                        <td width="25%">
                          {{ kontraktor.nib == null ? "-" : kontraktor.nib }}
                        </td>
                        <td>
                          <i
                            v-if="kontraktor.fileNib == null"
                            class="text-danger"
                            >Belum ada dokumen NIB</i
                          >
                          <a
                            v-else
                            @click="viewFile(kontraktor.fileNib)"
                            class="text-danger pointer"
                          >
                            <font-awesome-icon
                              style="color: #dd3737; cursor: pointer"
                              icon="fa-solid fa-eye"
                            />
                            Lihat NIB
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>No. IUJP</td>
                        <td>:</td>
                        <td>
                          {{ kontraktor.iujp == null ? "-" : kontraktor.iujp }}
                        </td>
                        <td>
                          <i
                            v-if="kontraktor.fileIujp == null"
                            class="text-danger"
                            >Belum ada dokumen IUJP</i
                          >
                          <a
                            v-else
                            @click="viewFile(kontraktor.fileIujp)"
                            class="text-danger pointer"
                          >
                            <font-awesome-icon
                              style="color: #dd3737; cursor: pointer"
                              icon="fa-solid fa-eye"
                            />
                            Lihat IUJP
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>Masa Berlaku</td>
                        <td>:</td>
                        <td>
                          {{
                            kontraktor.masaBerlaku == null
                              ? "-"
                              : moment(kontraktor.masaBerlaku).format(
                                  "DD MMMM YYYY",
                                )
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-md-3">
                <div
                  class="rounded w-100 p-3"
                  style="min-height: 10vh; background-color: #fff1f1"
                >
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    INFORMASI PJO
                  </p>
                  <p
                    class="mb-1"
                    style="font-family: 'Inter-Bold'; font-size: 1.1rem"
                  >
                    {{ kontraktor.namaPjo }}
                  </p>
                  <p
                    class="mb-1"
                    style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                  >
                    No. Surat Pengesahan : {{ kontraktor.noPengesahanPjo }}
                  </p>
                  <p
                    class="mb-1"
                    style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                  >
                    Tgl Surat Pengesahan :
                    {{
                      kontraktor.tglSuratPengesahan != "" &&
                      kontraktor.tglSuratPengesahan != null
                        ? moment(kontraktor.tglSuratPengesahan).format(
                            "DD MMM YYYY",
                          )
                        : "-"
                    }}
                  </p>
                  <p
                    class="mb-1"
                    style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                  >
                    <a
                      v-if="kontraktor?.filePengesahan"
                      @click="
                        downloadFile(
                          kontraktor.filePengesahan,
                          `File Pengesahan ${kontraktor.namaKontraktor}`,
                        )
                      "
                      class="text-danger cursor-pointer"
                    >
                      <font-awesome-icon
                        style="color: #dd3737; cursor: pointer"
                        icon="fa-solid fa-file-arrow-down"
                      />
                      Surat Pengesahan
                    </a>
                    <i v-else class="text-danger">
                      Belum ada Surat Pengesahan
                    </i>
                  </p>
                  <p
                    class="mb-1"
                    style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-user-check"
                      style="color: #df4444"
                    />
                    {{ kontraktor.kompetensiPjo }}
                  </p>
                  <p
                    class="mb-1 mt-2"
                    style="
                      font-family: 'Inter-Thin', serif;
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    INFORMASI PIC
                  </p>
                  <p
                    class="mb-1"
                    style="font-family: 'Inter-Medium'; font-size: 0.8rem"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-envelope"
                      style="color: #df4444"
                    />
                    {{ kontraktor.picEmail }}
                  </p>
                  <p
                    class="mb-1"
                    style="font-family: 'Inter-Medium'; font-size: 0.8rem"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-phone"
                      style="color: #df4444"
                    />
                    {{ kontraktor.picPhone }}
                  </p>
                </div>
              </div>
              <div class="col-md-12">
                <p
                  class="mb-1"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  Kode KBLI
                </p>
                <div class="table-responsive">
                  <table class="table table-striped rounded">
                    <thead
                      style="
                        font-family: 'Inter-Regular';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 24px;
                        color: #28293d;
                      "
                    >
                      <tr class="table-danger" style="max-height: 5vh">
                        <th width="6%">Kode</th>
                        <th width="20%">Judul</th>
                        <th class="text-center" width="14%">Tingkat Resiko</th>
                        <th class="text-center" width="10%">
                          Sertifikat Standar
                        </th>
                        <th class="text-center" width="10%">Izin</th>
                        <th class="text-center" width="8%">Is Verified</th>
                        <th class="text-center" width="13%">Catatan</th>
                        <th width="10%"></th>
                      </tr>
                    </thead>
                    <tbody
                      style="
                        font-family: 'Inter-Regular';
                        font-style: normal;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 24px;
                        color: #28293d;
                      "
                    >
                      <tr v-for="kb in kbli" :key="kb.noKbli">
                        <td>
                          {{
                            kb.noKbli.length == 4 ? "0" + kb.noKbli : kb.noKbli
                          }}
                        </td>
                        <td>{{ kb.deskripsi }}</td>
                        <td class="text-center">{{ kb.tingkatResikoStr }}</td>
                        <td class="text-center">
                          <a
                            v-if="
                              kb.fileSertifikat != null && kb.tingkatResiko != 4
                            "
                            @click="viewFile(kb.fileSertifikat)"
                            class="text-decoration-none text-dark pointer"
                          >
                            Terverifikasi
                            <font-awesome-icon
                              size="xl"
                              icon="fa-solid fa-file-arrow-down"
                              class="text-danger"
                            />
                          </a>
                          <a v-else>-</a>
                        </td>
                        <td class="text-center">
                          <a
                            v-if="kb.fileIzin != null && kb.tingkatResiko == 4"
                            @click="viewFile(kb.fileIzin)"
                            class="text-decoration-none text-dark pointer"
                          >
                            Terverifikasi
                            <font-awesome-icon
                              size="xl"
                              icon="fa-solid fa-file-arrow-down"
                              class="text-danger"
                            />
                          </a>
                          <a v-else>-</a>
                        </td>
                        <td class="text-start">
                          <img
                            :src="
                              kb.isVerified
                                ? require('@/assets/icons/verified.png')
                                : require('@/assets/icons/close-64.png')
                            "
                            alt="icon"
                            :style="{
                              width: kb.isVerified ? '6rem' : '4rem',
                              marginLeft: kb.isVerified ? '-0.8rem' : '0',
                            }"
                          />
                        </td>
                        <td>{{ kb.notes }}</td>
                        <td class="text-center">
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 1.2rem;
                              color: #dd3737;
                              cursor: pointer;
                            "
                            @click="hapusKBLI(kb.id)"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-trash"
                              style=""
                            />
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="flex justify-between mb-1">
              <p
                class="mb-1"
                style="
                  font-family: 'Inter-Thin';
                  font-size: 0.9rem;
                  letter-spacing: 0.1rem;
                  font-weight: bold;
                "
              >
                SUB KONTRAKTOR
              </p>
              <a
                style="
                  font-family: 'Inter-Bold';
                  font-size: 0.75rem;
                  color: #dd3737;
                "
                class="cursor-pointer text-decoration-none text-nowrap"
                data-bs-toggle="modal"
                data-bs-target="#request_sub_kontraktor"
              >
                <font-awesome-icon icon="fa-solid fa-circle-plus" style="" />
                Tambah Sub Kontraktor
              </a>
            </div>
            <div class="row mb-5" v-if="subkontraktor != null">
              <div class="col-md-12">
                <div
                  class="border border-1 border-light"
                  :class="{ 'bg-gray': index % 2 === 1 }"
                >
                  <div class="table-responsive">
                    <table class="table table-striped rounded">
                      <tbody
                        style="
                          font-family: 'Inter-Regular';
                          font-style: normal;
                          font-weight: 500;
                          font-size: 14px;
                          line-height: 24px;
                          color: #28293d;
                        "
                      >
                        <tr v-for="(sbk, index) in subkontraktor" :key="index">
                          <td width="5%">{{ index + 1 }}</td>
                          <td width="85%">
                            <a
                              class="pointer link-danger text-decoration-none"
                              style=""
                              @click="viewSubkontraktor(sbk.idKontraktor)"
                              >{{ sbk.namaKontraktor }}</a
                            >
                          </td>
                          <td>
                            <a
                              v-if="!sbk.isMainKontraktor"
                              class="text-danger pointer"
                              style="text-decoration: none"
                              @click="
                                redirectToLink(
                                  '/editprofile/',
                                  sbk.idKontraktor,
                                )
                              "
                            >
                              <font-awesome-icon icon="fa-solid fa-edit" /> </a
                            >&nbsp;&nbsp;
                            <a
                              class="text-danger pointer"
                              style="text-decoration: none"
                              @click="hapusSubkontraktor(sbk.idKontraktor)"
                            >
                              <font-awesome-icon icon="fa-solid fa-trash" />
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-5" v-else>
              <p
                class="mb-1 text-center"
                style="
                  font-family: 'Inter-Thin';
                  font-size: 0.9rem;
                  letter-spacing: 0.1rem;
                  font-weight: bold;
                "
              >
                Tidak Ada Subkontraktor
              </p>
            </div>
            <div class="row" v-if="kontraktor.bidang != null">
              <div class="col-md-4">
                <p
                  class="mb-1"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  BIDANG
                </p>
                <ul class="list-group w-100">
                  <li
                    v-for="(bid, index) in bd"
                    :key="index"
                    :class="{
                      'list-group-item': true,
                      'list-bidang': true,
                      'bg-gray': index % 2 === 1,
                    }"
                  >
                    {{ bid }}
                  </li>
                </ul>
              </div>
              <div class="col-md-8">
                <p
                  class="mb-1"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  SUB BIDANG
                </p>
                <table>
                  <tbody>
                    <tr
                      v-for="(sbid, index) in sbd"
                      :key="index"
                      :class="{ 'bg-gray': index % 2 === 1 }"
                    >
                      <td width="50%">{{ sbid.sb }}</td>
                      <td width="15%">
                        <img
                          :src="
                            sbid.is_verified
                              ? require('@/assets/icons/verified.png')
                              : require('@/assets/icons/close-64.png')
                          "
                          alt="icon"
                          :style="{
                            width: sbid.is_verified ? '6rem' : '4rem',
                            marginLeft: sbid.is_verified ? '.8rem' : '0',
                          }"
                        />
                      </td>
                      <td width="40%">{{ sbid.notes }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row" v-else>
              <p
                class="mb-1 text-center"
                style="
                  font-family: 'Inter-Thin';
                  font-size: 0.9rem;
                  letter-spacing: 0.1rem;
                  font-weight: bold;
                "
              >
                Tidak Ada Data Bidang dan Sub Bidang
              </p>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <div
    class="modal fade"
    id="request_sub_kontraktor"
    tabindex="-1"
    aria-labelledby="request_sub_kontraktorLabel"
    data-bs-backdrop="false"
    aria-hidden="true"
    style="z-index: 1060"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <div class="d-flex justify-content-end w-100">
            <button
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label for="namaKontraktor" class="form-label fs-8 fw-bold"
                >Nama Kontraktor <span class="text-danger fs-6">*</span></label
              >
              <input
                type="text"
                class="form-control fs-9"
                placeholder="Masukkan Nama Kontraktor"
                id="namaKontraktor"
                autocomplete="off"
                v-model="formValues.namaKontraktor"
                @input="getListKontraktor"
                @click="getListKontraktor"
              />
              <div
                :class="showAutocomplete ? 'd-block' : 'd-none'"
                ref="autocompleteList"
                class="position-relative"
                style="z-index: 2"
              >
                <ul
                  class="bg-body shadow-sm rounded w-100 fs-9 list-unstyled list-group position-absolute"
                >
                  <li
                    v-for="kont in listSubKontraktor"
                    :key="kont.id"
                    @click="getKontraktorById(kont.id)"
                    class="p-1 list-group-item-action pointer"
                  >
                    <p class="m-0 ms-2">{{ kont.namaKontraktor }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 mt-1">
            <button
              class="btn btn_cari w-100 fs-8 fw-bold"
              @click="handleSubmitSubKontraktor()"
              :disabled="
                !formValues.namaKontraktor ||
                formValues.namaKontraktor.trim() === ''
              "
            >
              {{
                listSubKontraktor.length === 0
                  ? "Lanjut Step Berikutnya"
                  : "Simpan"
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "../../GlobalDataMixin";

import axios from "axios";

import {
  API_BASE_URL,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_VIEW_IMAGE,
  CMS_DOWNLOAD,
  CMS_DELETE_KBLI,
  CMS_VIEW_DOCUMENT,
  CMS_GET_CHANGES_KONTRAKTOR,
  CMS_GET_SIOID,
  CMS_DOWNLOAD_ESIGN,
  CMS_GET_CHANGES_INFORMATION,
  CMS_GET_LIST_SUB_KONTRAKTOR,
  CMS_INSERT_NEW_SUB,
} from "../../constants.js";
import Swal from "sweetalert2";
import router from "@/router";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import { downloadFile } from "@/utilities/globalFunction";
import axiosInstance from "@/plugins/axios";
// import ModalComponent from "@/components/ModalComponent.vue";

const url = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_download = API_BASE_URL + CMS_DOWNLOAD;
const url_delete_kbli = API_BASE_URL + CMS_DELETE_KBLI;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;
const url_get_changes_kontraktor = API_BASE_URL + CMS_GET_CHANGES_KONTRAKTOR;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_download_esign = API_BASE_URL + CMS_DOWNLOAD_ESIGN;
const url_get_changes_information_kontraktor =
  API_BASE_URL + CMS_GET_CHANGES_INFORMATION;
const url_get_sub_kontraktor = API_BASE_URL + CMS_GET_LIST_SUB_KONTRAKTOR;
const url_insert_new_sub_kontraktor = API_BASE_URL + CMS_INSERT_NEW_SUB;

export default {
  mixins: [GlobalDataMixin],
  name: "ProfilePage",
  components: { DefaultLayout },
  data() {
    return {
      isLoading: true,
      kontraktor: {},
      bidang: [],
      kbli: [],
      bd: [],
      sbd: [],
      subkontraktor: [],
      url_icon: "",
      url_file_nib: "",
      url_file_iujp: "",
      dataChanges: {},
      changesInformation: {},
      sio: {},
      flashMessage: true,
      listSubKontraktor: [],
      detailSubKontraktor: {},
      formValues: {
        namaKontraktor: "",
        parentKontraktorId: "",
        subKontraktorId: "",
        namaPjo: "",
        kompetensiPjo: "",
        inisial: "",
        nib: "",
        noNib: "",
        iujp: "",
        noIujp: "",
        tglExpIujp: "",
        kblis: [],
        bidangs: [{ NMBIDANG: "", SUBBIDANG: "" }],
        fileDokumenPengesahan: "",
        fileDokumenIUJP: "",
        fileDokumenNIB: "",
        alamat: "",
        provinsi: "",
        emailPic: "",
        hpPic: "",
        kualifikasiUsaha: "",
      },
      showAutocomplete: false,
      idKontraktor: null,
      isDisabled: false,
      final_kblis: [],
    };
  },
  mounted() {
    this.fetchData(this.userData.kontraktorID);
    this.getChangesKontraktor(this.userData.kontraktorID);
    this.getSioID(this.userData.kontraktorID);
    this.getInformationChangesKontraktor(this.userData.kontraktorID);
    setTimeout(() => {
      this.flashMessage = false;
    }, 15000);
    //   const backdrops = document.querySelectorAll('.modal-backdrop');
    //   backdrops.forEach(el => el.remove());
    const modalElement = document.getElementById("request_sub_kontraktor");
    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", this.resetModalForm);
    }
  },
  unmounted() {
    document.removeEventListener("click", this.onClickOutsideListKontraktor);
  },
  methods: {
    downloadFile,
    fetchData(id) {
      axios
        .get(url + id)
        .then((response) => {
          console.log("kontraktor : ", response);
          this.kontraktor = response.data.detailKontraktor;
          this.idKontraktor = id;
          this.url_icon =
            this.kontraktor.image != null && this.kontraktor.image != ""
              ? API_BASE_URL + CMS_VIEW_IMAGE + this.kontraktor.image
              : "";
          this.url_file_nib =
            this.kontraktor.fileNib != null
              ? url_download + this.kontraktor.fileNib
              : null;
          this.url_file_iujp =
            this.kontraktor.fileIujp != null
              ? url_download + this.kontraktor.fileIujp
              : null;
          // loop bidang-subbidang
          var arr_bid = [];
          var abd = [];
          var asbd = [];
          var temp_key = "";
          var b = 0;
          var sb = 1;
          for (var key in this.kontraktor.bidang) {
            var subi = this.kontraktor.bidang[key];
            if (temp_key != key) {
              temp_key = key;
              b += 1;
              sb = 1;
            }
            abd.push(b + ". " + key);

            for (var xx in subi) {
              arr_bid.push({
                bidang: b + ". " + key,
                subBidang: b + "." + sb + ". " + subi[xx],
              });
              asbd.push({
                sb: b + "." + sb + ". " + subi[xx].split("-")[0],
                is_verified: JSON.parse(subi[xx].split("-")[1]),
                notes:
                  subi[xx].split("-")[2] === "null"
                    ? null
                    : subi[xx].split("-")[2],
              });
              sb++;
            }
          }
          this.bidang = arr_bid;
          // end loop bidang-subbidang
          console.log(this.kontraktor.bidang);

          this.kbli = response.data.dataKbli;
          this.bd = abd;
          this.sbd = asbd;
          this.subkontraktor = response.data.subkontraktor;
          this.isLoading = false;
        })
        .catch((error) => {
          alert("Error Fetch Data List Kontraktor : " + error.message);
          console.error("Error fetching data:", error);
        });
    },
    editProfile() {
      this.$router.push("/editprofile");
    },
    addSubkontraktor() {
      this.$router.push("/addsubkontraktor");
    },
    viewSubkontraktor(id) {
      this.$router.push("/subkontraktor/" + id);
    },
    hapusKBLI(id) {
      Swal.fire({
        title: "Hapus KBLI",
        text: "Apakah anda yakin akan menghapus data kbli ini ?",
        icon: "confirmation",
        showCancelButton: true,
        showConfirmButton: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteKbli(id);
        }
      });
    },
    deleteKbli(id) {
      const user = localStorage.getItem("user_cms");
      const tokens = JSON.parse(user);
      const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe";
      axios
        .get(url_delete_kbli, {
          params: {
            id: id,
          },
          headers: {
            role: role,
            Authorization: `Bearer ${tokens.token}`,
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Access-Control-Allow-Headers":
              "Content-Type, Authorization, Accept",
          },
        })
        .then(() => {
          Swal.fire({
            title: "Hapus KBLI",
            text: "Data KBLI telah dihapus !",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then(() => {
            window.location.reload();
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan (" + error.response.data.message + ")",
          });
        });
    },
    redirectToLink(link, id) {
      router.push(link + id);
    },
    hapusSubkontraktor(id) {
      Swal.fire({
        title: "Hapus Subkontraktor",
        text: "Apakah anda yakin akan menghapus data ini ?",
        icon: "confirmation",
        showCancelButton: true,
        showConfirmButton: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteKontraktor(id);
        }
      });
    },
    async deleteKontraktor(id) {
      try {
        await axiosInstance.delete("cms/kontraktor/subkontraktor", {
          data: {
            id: id,
            kontraktorId: this.userData.kontraktorID,
          },
          params: {
            updated_by: this.userData.email || "UNKNOWN",
          },
        });
      } catch (error) {
        console.log("error deleteKontraktor : ", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan (" + error.response.data.message + ")",
        });
      } finally {
        await Swal.fire({
          title: "Hapus SubKontraktor",
          text: "Data SubKontraktor telah dihapus !",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        }).then(() => {
          window.location.reload();
        });
      }
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
    getChangesKontraktor(kontraktorId) {
      let bodyJson = {
        kontraktorId: kontraktorId,
      };
      axios
        .post(url_get_changes_kontraktor, bodyJson, {
          headers: {
            role: "kontraktor",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          this.dataChanges = response.data;
          console.log(this.dataChanges);
        })
        .catch((error) => {
          console.log("error getChangesKontraktor : ", error);
        });
    },
    getInformationChangesKontraktor(kontraktorId) {
      let bodyJson = {
        kontraktorId: kontraktorId,
      };
      axios
        .post(url_get_changes_information_kontraktor, bodyJson, {
          headers: {
            role: "kontraktor",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          this.changesInformation = response.data;
          console.log(this.changesInformation);
        })
        .catch((error) => {
          console.log("error getInformationChangesKontraktor : ", error);
        });
    },
    getSioID() {
      axios
        .get(url_get_sioid + this.userData.kontraktorID, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Access-Control-Allow-Headers":
              "Content-Type, Authorization, Accept",
          },
        })
        .then((response) => {
          console.log("sio : ", response.data.data);
          // if (response.data.data != null) {
          this.sio = response.data.data;
          // }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    downloadFileEsign(id, type) {
      this.isLoading = true;
      let filename =
        type == "coc"
          ? `File CoC ${this.kontraktor.namaKontraktor}.zip`
          : `File Pengesahan PJO ${this.kontraktor.namaKontraktor}.zip`;
      axios
        .get(url_download_esign, {
          params: { id: id },
          headers: {
            role: this.userData.role,
            Authorization: `Bearer ${this.userData.token}`,
            Accept: "application/json",
          },
          responseType: "blob", // Ensure binary data handling
        })
        .then((response) => {
          if (response.status !== 200) {
            throw new Error("Network response was not ok");
          }
          // let filename = 'downloaded-file.zip'; // Default filename

          // surat coc => file coc nama kontraktor.zip
          // surat pjo => file pengesahan pjo nama kontraktor.zip
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); // Use the filename from the header or default one
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url); // Clean up the URL object
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error downloading file:", error);
        });
    },

    closeModal() {
      this.formValues.namaKontraktor = "";
      this.formValues.parentKontraktorId = "";
      this.formValues.subKontraktorId = "";
      this.showAutocomplete = false;
    },
    getListKontraktor() {
      if (
        this.formValues.namaKontraktor !== null &&
        this.formValues.namaKontraktor !== ""
      ) {
        axios
          .get(url_get_sub_kontraktor, {
            params: {
              namaKontraktor: this.formValues.namaKontraktor,
              page: 1,
              size: 10,
            },
            headers: {
              role: this.userData.role,
              Authorization: "Bearer " + this.userData.token,
              accept: "*/*",
            },
          })
          .then((response) => {
            this.listSubKontraktor = response.data.data;
            console.log("getListKontraktor => ", this.listSubKontraktor);

            // this.subkontraktor = response.data.data;
            this.showAutocomplete = true;
          })
          .catch(() => {});
      } else {
        this.showAutocomplete = false;
      }
    },

    fethSubKontkotrktorById(id) {
      axios
        .get(url + id)
        .then((response) => {
          console.log("kontraktor : ", response);
          this.detailSubKontraktor = response.data.detailKontraktor;
          this.formValues.namaKontraktor =
            this.detailSubKontraktor.namaKontraktor;
          this.formValues.inisial = this.detailSubKontraktor.inisial;
          this.formValues.jenis = this.detailSubKontraktor.jenis;
          this.formValues.namaPjo = this.detailSubKontraktor.namaPjo;
          this.formValues.nib = this.detailSubKontraktor.nib;
          this.formValues.noNib = this.detailSubKontraktor.noNib;
          this.formValues.iujp = this.detailSubKontraktor.iujp;
          this.formValues.noIujp = this.detailSubKontraktor.noIujp;
          this.formValues.tglExpIujp = this.detailSubKontraktor.tglExpIujp;
          this.formValues.kblis = this.detailSubKontraktor.kblis;
          this.formValues.bidangs = this.detailSubKontraktor.bidangs;
          this.formValues.fileDokumenPengesahan =
            this.detailSubKontraktor.fileDokumenPengesahan;
          this.formValues.fileDokumenIUJP =
            this.detailSubKontraktor.fileDokumenIUJP;
          this.formValues.tanggalPengesahan =
            this.detailSubKontraktor.tglSuratPengesahan;
          this.formValues.fileDokumenNIB =
            this.detailSubKontraktor.fileDokumenNIB;
          this.formValues.alamat = this.detailSubKontraktor.alamat;
          this.formValues.provinsi = this.detailSubKontraktor.provinsi;
          this.formValues.emailPic = this.detailSubKontraktor.emailPic;
          this.formValues.hpPic = this.detailSubKontraktor.hpPic;
          this.formValues.kualifikasiUsaha =
            this.detailSubKontraktor.kualifikasiUsaha;
          this.isLoading = false;
        })
        .catch((error) => {
          alert("Error Fetch Data List Kontraktor : " + error.message);
          console.error("Error fetching data:", error);
        });
    },
    getKontraktorById(id) {
      console.log("getKontraktorById()", id);
      this.idKontraktor = id;
      try {
        this.isLoading = true;
        this.isDisabled = true;
        this.fethSubKontkotrktorById(id);
        this.isLoading = false;
        this.showAutocomplete = false;
      } catch (error) {
        this.isDisabled = false;
        this.isLoading = false;
        this.formValues.namaKontraktor = "";
      }
    },
    onClickOutsideListKontraktor(event) {
      const clickedElement = event.target;
      const inputElement = this.$refs.autocompleteList;
      if (!inputElement.contains(clickedElement)) {
        this.showAutocomplete = false;
      }
    },
    handleSubmitSubKontraktor() {
      // if (this.listSubKontraktor.length === 0) {
      //   const namaKontraktor = this.formValues?.namaKontraktor?.trim();
      //   this.closeModal();

      //   if (namaKontraktor) {
      //     this.$router.push({
      //       path: "/addsubkontraktor",
      //       query: { nama: namaKontraktor }
      //     });
      //   } else {
      //     this.$router.push("/addsubkontraktor");
      //   }
      // } else {
      //   this.insertSubKontraktor();
      // }
      const nama = this.formValues?.namaKontraktor?.trim();
      if (!nama) return;

      if (this.listSubKontraktor.length === 0) {
        localStorage.setItem("kontraktor_nama_draft", nama);

        this.closeModal();
        this.$router.push("/addsubkontraktor");
      } else {
        this.insertSubKontraktor();
      }
    },
    resetModalForm() {
      this.formValues.namaKontraktor = null;
      this.listSubKontraktor = [];
      this.showAutocomplete = false;
    },
    insertSubKontraktor() {
      this.isLoading = true;
      let kontraktorId = this.userData.kontraktorID;
      let bodyJson = {
        parentKontraktor: parseInt(kontraktorId),
        id: this.idKontraktor,
        namaKontraktor: this.formValues.namaKontraktor,
        namaPjo: this.formValues.namaPjo,
        kompetensiPjo: this.formValues.kompetensiPjo,
        inisial: this.formValues.inisial,
        nib: this.formValues.nib != "" ? true : false,
        noNib: this.formValues.noNib,
        iujp:
          this.formValues.klasifikasi != "" &&
          this.formValues.klasifikasi != null &&
          this.formValues.klasifikasi != "Non Inti"
            ? true
            : false,
        noIujp: this.formValues.noIujp,
        tglExpIujp:
          this.formValues.masaBerlakuIUJP != null &&
          this.formValues.masaBerlakuIUJP != ""
            ? moment(this.formValues.masaBerlakuIUJP).format("YYYY-MM-DD")
            : null,
        kblis: this.final_kblis,
        bidangUsahaGems: JSON.stringify(this.formValues.bidangs),
        noPengesahanPjo: this.formValues.nomorSuratPengesahan,
        tglSuratPengesahan:
          this.formValues.tanggalPengesahan != null &&
          this.formValues.tanggalPengesahan != ""
            ? moment(this.formValues.tanggalPengesahan).format("YYYY-MM-DD")
            : null,
        alamat: this.formValues.alamat,
        provinsi: this.formValues.provinsi,
        picEmail: this.formValues.emailPic,
        picPhone: this.formValues.hpPic,
        kualifikasiUsaha: parseInt(this.formValues.kualifikasiUsaha),
      };
      console.log("insertSubKontraktor : ", bodyJson);

      axios
        .post(url_insert_new_sub_kontraktor, bodyJson, {
          headers: {
            role: "kontraktor",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("insertSubKontraktor : ", response.data);
          this.isLoading = false;
          Swal.fire({
            title: "Tambah Sub Kontraktor",
            text: "Data Sub Kontraktor telah ditambahkan !",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then(() => {
            window.location.reload();
          });
        })
        .catch((error) => {
          this.isLoading = false;
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              error.response.data.message != null
                ? error.response.data.message
                : error.message,
          });
        });
    },
  },
};
</script>
